module.exports = __webpack_public_path__ + "img/newsImg3-12.584d74e2.png";